import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import config from "../../config";

function TeamDetails() {
  const { id } = useParams();
  const [team, setTeam] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPostDetails = async () => {
      try {
        const response = await axios.get(
          `${config?.BASE_URL}/api/admin/get-team/${id}`
        );
        setTeam(response.data);
      } catch (err) {
        setError("Failed to fetch team details");
      } finally {
        setLoading(false);
      }
    };

    fetchPostDetails();
  }, [id]);

  const handleDelete = async () => {
    try {
      await axios.delete(
        `${config?.BASE_URL}/api/admin/delete-team/${id}`
      );

      navigate("/admin/teams");
    } catch (err) {
      setError("Failed to delete the team");
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="dashboard project_detail_wrap">
      <div className="content-container">
        <h1 className="dash_title">Dashboard</h1>
        <div className="back_btn_wrap">
          <button className="back-btn" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
        <div className="main-section">
          <div className="projects">
            <div className="projects-inner">
              <div className="detail_item">
                <h2>Name</h2>
                <div className="detail_item_inner">
                  <p>{team?.title}</p>
                </div>
              </div>

              <div className="detail_item">
                <h2>Position</h2>
                <div className="detail_item_inner">
                  <p>{team?.position}</p>
                </div>
              </div>

              <div className="detail_item">
                <div className="detail_banner_wrap">
                  <h2>Featured Image</h2>
                  <div className="detail_img_grid">
                    {team?.featuredImage ? (
                      <div className="detail_img_item">
                        <div className="banner_img_wrap">
                          <img
                            src={config?.BASE_URL + team?.featuredImage}
                          />
                        </div>
                      </div>
                    ) : (
                      <p>No image available.</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="update_btn_wrap">
                <button className="update_btn" onClick={handleDelete}>Delete Member</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamDetails;
